import type MenuItem from '../../Models/MenuItem';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import MenuListItemLink from '../MenuListItemLink/MenuListItemLink';
import Styles from '../Menu/Menu.module.scss';

function MenuUIItem({ item, addToFavorites, alwaysOpen }: Readonly<{
    item: MenuItem; addToFavorites: Function; alwaysOpen: boolean;
}>): React.ReactElement {
    const { t } = useTranslation();
    const [isUnfolded, setIsUnfolded] = useState(false);

    const toggleUnfold = (): void => {
        if (item.Action) {
            return;
        }
        setIsUnfolded(!isUnfolded);
    };

    return (
        <>
            { item.Action !== null || (item.Action === null && item.Controller !== null)
                ? <MenuListItemLink full={item} icon={item.IconClass} to={item.ID} primary={t(item.ID)} sub={false} addToFavorites={addToFavorites} />
                : (
                        <button onClick={toggleUnfold} className={alwaysOpen || isUnfolded ? (Styles.nav + ' ' + Styles.unfolded) : Styles.nav}>
                            <div className={Styles.navText}>{t(item.ID)}</div>
                            {isUnfolded ? <span className="material-symbols-outlined">keyboard_arrow_down</span> : <span className="material-symbols-outlined">keyboard_arrow_right</span>}
                        </button>
                    )}
            <div hidden={!alwaysOpen && !isUnfolded}>
                { item.MenuItemSub?.map((x) => <MenuListItemLink full={x} key={x.ID + x.Parameters} icon={x.IconClass} sub={true} to={x.ID} primary={t(x.WorklistFilterID ? x.Text : x.ID)} addToFavorites={addToFavorites} />) }
            </div>
        </>
    );
}

export default MenuUIItem;
